// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.settings-menu_icon_F9o4f {
    width: 1.5rem;
}

.settings-menu_theme-label_J7W4H {
    flex: 1;
}

.settings-menu_option_Bmq0t {
    display: flex;
    align-items: center;
    gap: .5rem;
}

.settings-menu_check_Mk9qT {
    margin: 0 .25rem 0 0;
    visibility: hidden;
}

[dir="rtl"] .settings-menu_check_Mk9qT {
    margin: 0 0 0 .25rem;
}

.settings-menu_selected_JImeI {
    visibility: visible;
}

.settings-menu_submenu-label_WTCzu {
    flex: 1;
}

.settings-menu_dropdown-label_PnHC3 {
    margin: 0 0.5rem 0 0.25rem;
}

[dir="rtl"] .settings-menu_dropdown-label_PnHC3 {
    margin: 0 0.25rem 0 0.5rem;
}

.settings-menu_expand-caret_G5vQu {
    transform: rotate(-90deg);
}

[dir="rtl"] .settings-menu_expand-caret_G5vQu {
    transform: rotate(90deg);
}

/* Extra padding to deal with scrollbar overlapping options in Firefox */

[dir="ltr"] .settings-menu_language-menu-item_RTmN5 {
    padding-right: 1rem;
}

[dir="rtl"] .settings-menu_language-menu-item_RTmN5 {
    padding-left: 1rem;
}

.settings-menu_language-submenu_GptV0 > ul {
    max-height: calc(100vh - 5rem); /* Fallback if dvh not supported */
    max-height: calc(100dvh - 5rem);
}

@media only screen and (max-width: 1124px) {
    .settings-menu_dropdown-label_PnHC3 {
        display: none;
    }
}

.settings-menu_accent-icon-outer_yL_Wv {
    width: 24px;
    height: 24px;
    border: 3px solid var(--menu-bar-foreground);
    border-radius: 100%;
    box-sizing: border-box;
    transform-origin: center;
    transform: scale(90%);
}

.settings-menu_disabled_EL_fv {
    opacity: 0.5;
}

.settings-menu_disabled_EL_fv img {
    filter: grayscale(100%);
}

.settings-menu_open-link_DedrQ {
    margin-left: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/menu-bar/settings-menu.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,aAAa;AACjB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,wEAAwE;;AAExE;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,8BAA8B,EAAE,kCAAkC;IAClE,+BAA+B;AACnC;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4CAA4C;IAC5C,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.icon {\n    width: 1.5rem;\n}\n\n.theme-label {\n    flex: 1;\n}\n\n.option {\n    display: flex;\n    align-items: center;\n    gap: .5rem;\n}\n\n.check {\n    margin: 0 .25rem 0 0;\n    visibility: hidden;\n}\n\n[dir=\"rtl\"] .check {\n    margin: 0 0 0 .25rem;\n}\n\n.selected {\n    visibility: visible;\n}\n\n.submenu-label {\n    flex: 1;\n}\n\n.dropdown-label {\n    margin: 0 0.5rem 0 0.25rem;\n}\n\n[dir=\"rtl\"] .dropdown-label {\n    margin: 0 0.25rem 0 0.5rem;\n}\n\n.expand-caret {\n    transform: rotate(-90deg);\n}\n\n[dir=\"rtl\"] .expand-caret {\n    transform: rotate(90deg);\n}\n\n/* Extra padding to deal with scrollbar overlapping options in Firefox */\n\n[dir=\"ltr\"] .language-menu-item {\n    padding-right: 1rem;\n}\n\n[dir=\"rtl\"] .language-menu-item {\n    padding-left: 1rem;\n}\n\n.language-submenu > ul {\n    max-height: calc(100vh - 5rem); /* Fallback if dvh not supported */\n    max-height: calc(100dvh - 5rem);\n}\n\n@media only screen and (max-width: 1124px) {\n    .dropdown-label {\n        display: none;\n    }\n}\n\n.accent-icon-outer {\n    width: 24px;\n    height: 24px;\n    border: 3px solid var(--menu-bar-foreground);\n    border-radius: 100%;\n    box-sizing: border-box;\n    transform-origin: center;\n    transform: scale(90%);\n}\n\n.disabled {\n    opacity: 0.5;\n}\n\n.disabled img {\n    filter: grayscale(100%);\n}\n\n.open-link {\n    margin-left: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
export var icon = `settings-menu_icon_F9o4f`;
var _1 = `settings-menu_theme-label_J7W4H`;
export { _1 as "theme-label" };
export var themeLabel = `settings-menu_theme-label_J7W4H`;
export var option = `settings-menu_option_Bmq0t`;
export var check = `settings-menu_check_Mk9qT`;
export var selected = `settings-menu_selected_JImeI`;
var _2 = `settings-menu_submenu-label_WTCzu`;
export { _2 as "submenu-label" };
export var submenuLabel = `settings-menu_submenu-label_WTCzu`;
var _3 = `settings-menu_dropdown-label_PnHC3`;
export { _3 as "dropdown-label" };
export var dropdownLabel = `settings-menu_dropdown-label_PnHC3`;
var _4 = `settings-menu_expand-caret_G5vQu`;
export { _4 as "expand-caret" };
export var expandCaret = `settings-menu_expand-caret_G5vQu`;
var _5 = `settings-menu_language-menu-item_RTmN5`;
export { _5 as "language-menu-item" };
export var languageMenuItem = `settings-menu_language-menu-item_RTmN5`;
var _6 = `settings-menu_language-submenu_GptV0`;
export { _6 as "language-submenu" };
export var languageSubmenu = `settings-menu_language-submenu_GptV0`;
var _7 = `settings-menu_accent-icon-outer_yL_Wv`;
export { _7 as "accent-icon-outer" };
export var accentIconOuter = `settings-menu_accent-icon-outer_yL_Wv`;
export var disabled = `settings-menu_disabled_EL_fv`;
var _8 = `settings-menu_open-link_DedrQ`;
export { _8 as "open-link" };
export var openLink = `settings-menu_open-link_DedrQ`;
export default ___CSS_LOADER_EXPORT___;
